<template>
  <v-container fluid class="pa-0">
    <!--TOOLBAR-->
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("states.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-text-field
        v-model="search"
        :label="$t('states.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
      />
      <v-spacer class="hidden-sm-and-down" />
      <v-btn
        v-if="
          $store.getters.role == 'LekoAdmin' ||
          $store.getters.role == 'LekoEmployee' ||
          $store.getters.role == 'SuperAdmin'
        "
        color="grey-darken-4"
        variant="flat"
        @click="newState"
      >
        {{ $t("states.button") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>
    <!--ALERT-->
    <v-alert
      :model-value="alert.value"
      type="error"
      variant="tonal"
      border="bottom"
    >
      {{ alert.message }}
    </v-alert>
    <!--EDIT DIALOG-->
    <edit-dialog ref="editDialog" @save="save" @close="close" @error="error" />
    <!--DATATABLE-->
    <datatable ref="datatable" :search="search" @edit="edit" />
  </v-container>
</template>

<script>
// import ManageStates from '@/components/States/States.vue';
import EditDialog from "@/components/States/dialog.vue";
import Datatable from "@/components/States/datatable.vue";

export default {
  components: {
    // 'manage-states': ManageStates,
    "edit-dialog": EditDialog,
    datatable: Datatable,
  },
  data: () => ({
    search: "",
    alert: {
      value: false,
      message: "",
    },
  }),
  watch: {
    search(value) {
      const { datatable } = this.$refs;
      datatable.search(value);
    },
  },
  methods: {
    newState() {
      const { editDialog } = this.$refs;
      editDialog.open(false, null);
    },
    edit(data) {
      const { editDialog } = this.$refs;
      editDialog.open(true, data);
    },
    save() {},
    close() {
      const { datatable } = this.$refs;
      datatable.getStates();
    },
    error() {
      this.alert = { value: true, message: "An unexpected error occurred!" };
      setTimeout(() => {
        this.alert = { value: false, message: "" };
      }, 2000);
    },
  },
};
</script>
